import { getEnglishComparePageBySlug } from "@/app/seo-compare-en";
import { CompareLayoutEn } from "./CompareLayoutEn";

export default function EnglishHotlineVsSkills() {
  const page = getEnglishComparePageBySlug("hotline-vs-skills");
  if (!page) return null;
  return <CompareLayoutEn page={page} />;
}
